
import { RevLink } from '@ds/components/Link'
import { RevPopover } from '@ds/components/Popover'
import { RevTag } from '@ds/components/Tag'
import { RevTooltip } from '@ds/components/Tooltip'
import { IconInfo } from '@ds/icons/IconInfo'

export default {
  components: {
    IconInfo,
    RevLink,
    RevPopover,
    RevTag,
    RevTooltip,
  },
  props: {
    details: {
      type: Array,
      required: true,
    },
  },
  computed: {
    tooltipModifiers() {
      return [
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['top'],
          },
        },
      ]
    },
  },
}
